import { NavLink } from 'react-router-dom';
import classes from './MainNavigation.module.css';
import Header from './Header';
import Sidebar from './SideBar';

export default function MainNavigation({toggleSidebar, isSidebarVisible}) {
  return (
    // <Sidebar isVisible={isSidebarVisible} />
    // <Header toggleSidebar={toggleSidebar} />

    <>
  <Sidebar isVisible={isSidebarVisible} />
  <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
  </>

  );
}

;

